'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _createReducer;

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function userLogin(usersState, _ref) {
  var user = _ref.user,
      token = _ref.token;

  if (!process.env.REACT_APP_SERVER && token) {
    window.localStorage.setItem('user_token', token);
  }

  return (0, _extends3.default)({}, usersState, {
    token: token,
    user: user,
    loginError: null,
    isFetching: false
  });
}

function userSet(userState, _ref2) {
  var user = _ref2.user;

  return (0, _extends3.default)({}, userState, {
    isFetching: false,
    user: user
  });
}

function userLogout(usersState) {
  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.removeItem('user_token');
  }

  return (0, _extends3.default)({}, usersState, {
    token: null,
    user: null,
    loginError: null,
    isFetching: false
  });
}

function userLoginError(usersState, _ref3) {
  var message = _ref3.message;

  return (0, _extends3.default)({}, usersState, {
    loginError: message,
    isFetching: false
  });
}

function rehydrate() {
  var token = !process.env.REACT_APP_SERVER ? window.localStorage.getItem('user_token') || null : null;
  return {
    token: token,
    user: null,
    loginError: null,
    isFetching: !!token
  };
}

var reducer = (0, _createReducer3.default)({}, (_createReducer = {
  '@@redux/INIT': rehydrate
}, (0, _defineProperty3.default)(_createReducer, _actions.USER_LOGIN, userLogin), (0, _defineProperty3.default)(_createReducer, _actions.USER_SET, userSet), (0, _defineProperty3.default)(_createReducer, _actions.USER_LOGOUT, userLogout), (0, _defineProperty3.default)(_createReducer, _actions.USER_LOGIN_ERROR, userLoginError), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/User/reducer.js
// module id = 894
// module chunks = 0